
package com.ervasstudio.tracoemovimento.pages.sobre

import androidx.compose.runtime.Composable
import com.ervasstudio.tracoemovimento.components.sections.Header
import com.ervasstudio.tracoemovimento.util.rememberIsMobile
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import org.jetbrains.compose.web.css.vw

@Page
@Layout(".components.layouts.PageLayout")
@Composable
fun SobrePage() {
    val isMobile = rememberIsMobile()

    Column(
        modifier = Modifier
            .width(100.vw)
            .fillMaxHeight(),
        verticalArrangement = Arrangement.Top,
        horizontalAlignment = Alignment.CenterHorizontally
    ) {

        Header(expandedItem = 1, isMobile = isMobile)
        MainSectionSobre(isMobile)
    }
}